import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import { hashHistory, Link } from 'react-router';
import { Select } from 'antd';

const Option = Select.Option;

export default class ObservationAdminPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    let path = props.location.pathname;

    let currentSemester = SharedTools.getCurrentSemester();
    this.state = {
      role: CurrentRoleStore.getCurrentRole(),
      classes: [],
      schoolId: null,
      info: path.indexOf('observation') >= 0 ? "observation" : (path.indexOf('class-evaluation') >= 0 ? "classEvaluation" : (path.indexOf('report') >= 0 ? "report" : "evaluation")),
      graduatedArray: [],
      showGraduated: false,
      semesters: [],
      currentSemester,
      semester: currentSemester
    };
    // bind this
    this.toClassDetail = this.toClassDetail.bind(this);
  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onRolesChange);
    let schoolId;
    if (this.state.role.associatName == 'school') {
      schoolId = this.state.role.associatObj.id;
    } else {
      schoolId = this.state.role.associatObj.schoolId;
    }

    this.setState({
      schoolId: schoolId,
    })
    let data = {
      school_id: schoolId,
      info: this.state.info == 'classEvaluation' ? 'evaluation' : 'observation',
      semester: this.state.semester
    }
    this.loadClasses(data);


    // 学期列表
    let semesters = SharedTools.getAllSemesters(this.state.currentSemester, 20201);

    // 设置默认学期为该年份第一个学期
    this.setState({
      semesters
    })
  }

  componentWillReceiveProps(nextProps) {
    let path = nextProps.location.pathname;
    let info = path.indexOf('observation') >= 0 ? "observation" : (path.indexOf('class-evaluation') >= 0 ? "classEvaluation" : (path.indexOf('report') >= 0 ? "report" : "evaluation"));
    let data = {
      school_id: this.state.schoolId,
      info: info == 'classEvaluation' ? 'evaluation' : 'observation',
      semester: this.state.currentSemester
    }
    this.setState({
      info,
      semester: this.state.currentSemester
    })
    this.loadClasses(data);
  }

  componentWillUnmount() {
    CurrentRoleStore.removeChangeListener(this.onRolesChange);
  }

  loadClasses(data) {
    let that = this;
    DataService.getClassList(data).then((classes) => {
      let classGradeListTemp = {};
      let classGradeList = [], graduatedArray = [];
      classes.forEach(function (classItem) {
        if (classGradeListTemp["grade_id"+classItem.class_grade_id]) {
          classGradeListTemp["grade_id"+classItem.class_grade_id].classList.push(classItem)
        } else {
          classGradeListTemp["grade_id"+classItem.class_grade_id] = {
            id: classItem.class_grade_id,
            name: classItem.grade_name,
            is_graduated: classItem.is_graduated,
            graduate_date: classItem.graduate_date,
            classList: [classItem],
          }
        }
      })
      for (let item in classGradeListTemp) {
        if (classGradeListTemp[item] && !classGradeListTemp[item].is_graduated) {
          classGradeList.push(classGradeListTemp[item])
        } else {
          graduatedArray.push(classGradeListTemp[item])
        }
      }
      if (that.state.role.associatName == 'classGrade') {
        let classGradeListGrade = [];
        classGradeListGrade.push(classGradeList.find(function (grade) {
          return grade.id == that.state.role.associatObj.id
        }))

        this.setState({
          classes: classGradeListGrade,
          graduatedArray: graduatedArray.filter((grade) => grade.id == that.state.role.associatObj.id),
          schoolId: data.school_id,
        });
      } else {
        this.setState({
          classes: classGradeList,
          graduatedArray,
          schoolId: data.school_id,
        });
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  toolGraduatedDate(date) {
    return date ? (new Date(date).getFullYear() + '年') : ''
  }

  toClassDetail(e) {
    let classId = e.currentTarget.dataset.id, className = e.currentTarget.dataset.name, gradeId = e.currentTarget.dataset.gradeid;
    let info = this.state.info;
    if (info == "observation") {
      hashHistory.push(`development/observation-record/classes/${classId}?semester=${this.state.semester}`)
    } else if (info == "evaluation"){
      hashHistory.push(`development/evaluation-record/classes/${classId}?semester=${this.state.semester}`)
    } else if (info == "classEvaluation"){
      hashHistory.push(`development/class-evaluation/classes/${classId}?semester=${this.state.semester}`)
    } else if (info = "report") {
      hashHistory.push(`development/report/classes/${classId}?className=${className}&gradeId=${gradeId}&semester=${this.state.semester}`)
    }
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      }, () => {
        let data = {
          school_id: this.state.schoolId,
          info: this.state.info == 'classEvaluation' ? 'evaluation' : 'observation',
          semester: this.state.semester
        }
        this.loadClasses(data)
      })
    }
  }

  _selectSemesterBox() {
    return (
      <div className="select-semester-box">
        <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester.bind(this)}>
          {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
        </Select>
      </div>
    )
  }

  render() {
    return (
      <div className="albums-manage-page archive-content-setting-class-page">
        {this._selectSemesterBox()}
        <div className="classes-wrapper">
          {this.state.classes.map(grade =>
            <div key={grade.id} style={{ marginBottom: '40px' }}>
              <div className="class-grade">{grade.name}</div>
              {grade.classList.map(classItem =>
                <div className="class-box" key={classItem.id} data-id={classItem.id} data-gradeid={classItem.class_grade_id} data-name={classItem.name} onClick={this.toClassDetail}>
                  <div className="class-box-name" >{classItem.name}</div>
                  {this.state.info == 'observation' ?
                    <div className="class-box-info" >发展记录：{classItem.observation_count}</div> :
                    (this.state.info == 'classEvaluation' ? <div className="class-box-info">发展记录：{classItem.complete_count}/{classItem.evaluation_count}</div> : '')
                  }
                </div>
              )}
            </div>
          )}
          {/* <div style={{ color: '#4DA1FF', marginBottom: '20px', cursor: 'pointer' }} onClick={() => this.setState({ showGraduated: !this.state.showGraduated })}>{this.state.showGraduated ? '收起' : '查看'}毕业班级</div> */}
          {/* {this.state.showGraduated && this.state.graduatedArray.map(grade =>
            <div key={grade.id} style={{ marginBottom: '40px' }}>
              <div className="class-grade">{grade.name} - {this.toolGraduatedDate(grade.graduate_date)}毕业</div>
              {grade.classList.map(classItem =>
                <div className="class-box" key={classItem.id} data-id={classItem.id} onClick={this.toClassDetail}>
                  <div className="class-box-name" >{classItem.name}</div>
                  {(this.state.info == 'album') && <div className="class-box-info" >共有{classItem.album_count}个相册</div>}
                  {(this.state.info == 'file') && <div className="class-box-info" >共有{classItem.photo_count}张照片 {classItem.video_count}个视频</div>}
                </div>
              )}
            </div>
          )} */}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/development/ObservationAdminPage.jsx